import { getJson, postJson, patchJson, putJson, del } from './fetch';

const apiBase = process.env.REACT_APP_API_BASE;

const location = window.location;

export const postLogin = payload =>
  postJson({
    path: `${apiBase}/identity/login`,
    payload
  });
// postJson({
//   path: `${apiBase}/identity/login`,
//   payload
// }).then(result => {
//   localForage.setItem('identity', result);
//   return result;
// });

export const postLogout = () =>
  postJson({
    path: `${apiBase}/identity/logout`,
    payload: {}
  }).then(() => location.reload());

export const validateLogin = () =>
  getJson({
    path: `${apiBase}/identity/validate`
  });

export const postSignUp = payload =>
  postJson({
    path: `${apiBase}/identity/sign-up`,
    payload
  }).then(result => {
    return result;
  });

export const getShopProducts = () =>
  getJson({
    path: `${apiBase}/shop/products`
  });

export const getShopProductBySlug = slug =>
  getJson({
    path: `${apiBase}/shop/products/${slug}`
  });

export const postAddress = ({ payload, id }) =>
  postJson({
    path: `${apiBase}/account/address`,
    payload
  });

export const putAddress = ({ payload, id, addressId }) =>
  putJson({
    path: `${apiBase}/account/address/${addressId}`,
    payload
  });

export const postCard = ({ payload, id }) =>
  postJson({
    path: `${apiBase}/account/card`,
    payload
  });

export const putCard = ({ payload, id }) =>
  putJson({
    path: `${apiBase}/account/card`,
    payload
  });

export const putBirthday = ({ payload, id }) =>
  putJson({
    path: `${apiBase}/account/birthday`,
    payload
  });

export const putPassword = ({ payload, id }) =>
  putJson({
    path: `${apiBase}/account/password`,
    payload
  });

export const postAddToCart = ({ payload }) =>
  postJson({
    path: `${apiBase}/cart`,
    payload
  });

export const getCart = () =>
  getJson({
    path: `${apiBase}/cart`
  });

export const postCartShipping = ({ payload }) =>
  postJson({
    path: `${apiBase}/cart/shipping`,
    payload
  });

export const getCartShipping = () =>
  getJson({
    path: `${apiBase}/cart/shipping`
  });

export const postCartBilling = ({ payload }) =>
  postJson({
    path: `${apiBase}/cart/billing`,
    payload
  });

export const getCartBilling = () =>
  getJson({
    path: `${apiBase}/cart/billing`
  });

export const getLookups = () =>
  getJson({
    path: `${apiBase}/lookups`
  });

export const deleteCartItem = shoppingCartItemId =>
  del({
    path: `${apiBase}/cart/items/${shoppingCartItemId}`
  });

export const putCartItem = ({ id, payload }) =>
  putJson({
    path: `${apiBase}/cart/items/${id}`,
    payload
  });

export const postCompleteOrder = payload =>
  postJson({
    path: `${apiBase}/cart/payment`,
    payload
  });

export const getOrder = id =>
  getJson({
    path: `${apiBase}/orders/${id}`
  });

export const postValidateAddress = payload =>
  postJson({
    path: `${apiBase}/address/validate`,
    payload
  });

export const postPromoCode = payload =>
  postJson({
    path: `${apiBase}/cart/coupons`,
    payload
  });

export const delPromoCode = () =>
  del({
    path: `${apiBase}/cart/coupons`
  });

export const postEmailPref = ({ payload }) =>
  postJson({
    path: `${apiBase}/contact/stay-in-loop`,
    payload
  });

export const postStayInLoop = ({ payload }) =>
  postJson({
    path: `${apiBase}/contact/stay-in-loop`,
    payload
  });

export const postVerifyAccount = payload =>
  postJson({
    path: `${apiBase}/identity/verify`,
    payload
  });

export const postForgotPassword = payload =>
  postJson({
    path: `${apiBase}/identity/request-password`,
    payload
  });

export const postVerifyForgotPasswordToken = payload =>
  postJson({
    path: `${apiBase}/identity/reset-password/validate`,
    payload
  });

export const postResetPassword = payload =>
  postJson({
    path: `${apiBase}/identity/reset-password`,
    payload
  });

export const deleteAddress = addressId =>
  del({
    path: `${apiBase}/account/address/${addressId}`
  });

export const deleteCard = cardId =>
  del({
    path: `${apiBase}/account/card/${cardId}`
  });

export const postNameAndEmail = ({ payload }) =>
  postJson({
    path: `${apiBase}/account/name-and-email`,
    payload
  });

export const postSecondaryContact = ({ payload }) =>
  postJson({
    path: `${apiBase}/account/secondary-contact`,
    payload
  });

export const patchSecondaryContact = ({ payload }) =>
  patchJson({
    path: `${apiBase}/account/secondary-contact/:SecondaryContactId`,
    payload
  });

export const getOrderHistory = () =>
  getJson({
    path: `${apiBase}/orders`
  });

export const getCheckZip = zip =>
  getJson({
    path: `${apiBase}/address/validate/zip/${zip}`
  }).catch(err => {
    return { err };
  });

//club
export const getClubById = ({ clubTypeId, include }) =>
  getJson({
    path: `${apiBase}/club/${clubTypeId}`,
    payload: { include }
  })

export const getClubDisableTypes = () =>
  getJson({
    path: `${apiBase}/club/lookups`,
  })

export const cancelMembership = (payload) =>
  postJson({
    path: `${apiBase}/club/cancel-membership`,
    payload
  })

export const joinWaitList = (payload) =>
  postJson({
    path: `${apiBase}/club/join-wait-list`,
    payload
  })

export const acceptInvitation = (payload) =>
  postJson({
    path: `${apiBase}/club/accept-invitation`,
    payload
  })

export const getUserWaitListStatus = () =>
  getJson({
    path: `${apiBase}/club/waitlist-status`
  })

export const createClubMembershipCart = (payload) =>
  postJson({
    path: `${apiBase}/cart/club-cart`,
    payload
  })

export const switchClubMembership = (payload) =>
  postJson({
    path: `${apiBase}/club/switch`,
    payload
  })

export const deleteWaitlist = (payload) =>
  postJson({
    path: `${apiBase}/club/delete-waitlist`,
    payload
  })

export const getAddressSuggestions = (payload) =>
  postJson({
    path: `${apiBase}/address/autocomplete-address`,
    payload
  })